import { render, staticRenderFns } from "./comp_dpc-ImagesCarousel.vue?vue&type=template&id=36de2cf8&scoped=true&"
import script from "./comp_dpc-ImagesCarousel.vue?vue&type=script&lang=js&"
export * from "./comp_dpc-ImagesCarousel.vue?vue&type=script&lang=js&"
import style0 from "./comp_dpc-ImagesCarousel.vue?vue&type=style&index=0&id=36de2cf8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36de2cf8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
